module.exports = __webpack_public_path__ + "static/img/what-makes-us-different.58ca2af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/what-makes-us-different.png
// module id = KPg7
// module chunks = 0